import React from 'react'
import confidence from 'assets/confidence.svg'
import options from 'assets/options.svg'
import check from 'assets/check.svg'
const OurApproachSolutionProcess = () => {
  return (
    <div className='relative w-full mt-5 pb-36 md:pb-[300px]'>
      <div className='relative px-2.5 sm:px-4 md:p-6 lg:px-10 xl:px-16 2xl:px-20 box-border'>
        <div className='w-full max-w-[1028px] mx-auto md:pb-30'>
          <h3 className='text-2xl sm:text-xl md:text-2xl lg:text-3xl xl:text-4xl 2xl:text-5xl font-bold text-[#101828] leading-none tracking-wide text-center md:mb-8'>
            Our approach is your solution
          </h3>
          <p className='text-[#818285] text-center text-sm md:text-base lg:text-lg font-medium md:font-bold leading-6 tracking-wide mt-3'>
            Getting legal help has now changed. You can get access to legal
            information yourself, create legal documents yourself, and locate
            the right lawyer based on your precise needs. Our approach is to
            give you the confidence, choice, and control over the solution you
            want to solve your legal issue.
          </p>
        </div>
        <div className='w-full max-w-[1500px] mx-auto'>
          <div className='flex md:flex-row flex-wrap justify-center gap-4 md:gap-7 my-2 md:my-3'>
            {[
              { image: confidence, title: 'Build your confidence' },
              { image: options, title: 'Discover your options' },
              { image: check, title: 'Choose what works for you' },
            ].map((box) => (
              <div
                className='border border-[#BBC7D7] bg-[#FFFFFF] shadow-[0px_4px_50px_0px_rgba(0,0,0,0.08)] text-center 
            rounded-[20px] md:rounded-[40px] px-[20px] py-[24px] md:px-[30px] md:py-[40px] box-border
            md:w-full w-1/2 md:max-w-[330px] mx-auto'
              >
                <div className='w-full'>
                  <img
                    src={box.image}
                    className='h-8 w-8 md:h-16 md:w-16 block mx-auto'
                  />
                  <h3 className='text-lg sm:text-xl md:text-2xl lg:text-3xl font-bold'>
                    {box.title}
                  </h3>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}
export default OurApproachSolutionProcess
